import $ from "jquery";
import { scrollToFixed } from "./components/scrollToFixed";
import { enableAnchorScroll } from './components/anchor.js';
import { handleProgramMore } from "./components/readMore.js";

window.$ = $;
window.jQuery = $;
let currentStep = null;

const initAnchorScroll = () => {
    const anchorE = document.querySelector('.jsFixedNav01');
    if (!anchorE) return;
    let stepSpace;
    if (window.innerWidth <= 768) {
        stepSpace = 190;
    } else {
        stepSpace = window.innerWidth <= 992 ? 175 : 126;
    }
    if (stepSpace === currentStep) return;
    currentStep = stepSpace;
    enableAnchorScroll({
        elFixedHeight: 52,
        stepSpace,
        selector: '.jsFixedNav01 a[href^="#"]',
    });
};

const resetMenuState = () => {
    const $nav = $(".jsFixedNav01");
    $nav.find(".c-anchor02__subList").removeAttr("style");
    $nav.find(".c-anchor02__item").removeClass("hasHover active is-open");
};

$(document).ready(function () {
    const $nav = $(".jsFixedNav01");

    // --- Scroll to Top ---
    if ($(".js-about-top").length) {
        $(window).on("scroll", function () {
            if ($(window).scrollTop() < 10) {
                $(".js-about-top").removeClass("show");
            } else {
                $(".js-about-top").addClass("show");
            }
        });
        $(".js-about-top").on("click", function (e) {
            e.preventDefault();
            $("html, body").stop().animate({ scrollTop: 0 }, 500);
        });
    }

    // --- Menu Nav (Desktop Hover & Mobile Click) ---
    if ($nav.length) {
        // Desktop: Hover (Dùng event delegation để tránh lỗi khi resize)
        $(document).on({
            mouseenter: function () {
                if (window.innerWidth > 768) {
                    $(this).addClass("hasHover")
                           .find(".c-anchor02__subList").stop().fadeIn("fast");
                }
            },
            mouseleave: function () {
                if (window.innerWidth > 768) {
                    $(this).removeClass("hasHover")
                           .find(".c-anchor02__subList").stop().fadeOut("fast");
                }
            }
        }, ".jsFixedNav01 .c-anchor02__list > li");

        // Mobile: Click Toggle (Dùng event delegation)
        $(document).on("click", ".jsFixedNav01 .c-anchor02__list > li > a", function (e) {
            if (window.innerWidth <= 768) {
                const $li = $(this).parent();
                const $subList = $li.find(".c-anchor02__subList");
                if ($subList.length) {
                    e.preventDefault();
                    // Đóng các menu khác đang mở
                    $li.siblings().find(".c-anchor02__subList").stop().slideUp("fast");
                    $li.siblings().removeClass("is-open");
                    // Toggle menu hiện tại
                    $li.toggleClass("is-open");
                    $subList.stop().slideToggle("fast");
                }
            }
        });

        // --- Smooth Scroll cho tất cả Anchor Links ---
        $(document).on("click", 'a[href^="#"]', function (e) {
            const anchorLink = $(this).attr("href");
            if (anchorLink === "#") return;
            const $target = $(anchorLink);
            if ($target.length) {
                e.preventDefault();
                // Đóng submenu trên mobile sau khi click chọn item
                if (window.innerWidth <= 768) {
                    $(".c-anchor02__subList").stop().slideUp("fast");
                    $(".c-anchor02__item").removeClass("is-open");
                }
                const headerHeight = $("#header").outerHeight() || 0;
                const navHeight = $nav.outerHeight() || 0;
                let offTop = $target.offset().top - headerHeight - navHeight;
                if (window.innerWidth > 765) {
                    offTop -= 20;
                }
                $("body, html").stop().animate({ scrollTop: offTop }, 500);
            }
        });

        scrollToFixed(".jsFixedNav01", {
            marginTop: () => $("#header").outerHeight() || 0,
            spacerClass: "scroll-to-fixed-spacer",
            zIndex: 999
        });
    }
    initAnchorScroll();
    handleProgramMore();
});

// --- Resize với Debounce ---
let resizeTimer;
window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        initAnchorScroll();
        resetMenuState();
    }, 200);
});
